"use client";
import styles from "./sign-out-button.module.css";
import { useServerAction } from "zsa-react";
import { signOutAction } from "@/components/auth-dialog/actions";
import { usePathname, useRouter } from "next/navigation";
import { MdLogout } from "react-icons/md";
import { useLocale, useTranslations } from "next-intl";

export default function SignOutButton() {
  const router = useRouter();
  const pathName = usePathname();
  const locale = useLocale();
  const { execute } = useServerAction(signOutAction);
  const t = useTranslations("MyAccount.SignOut");
  return (
    <button
      onClick={async (e) => {
        e.preventDefault();
        localStorage.removeItem("lastListingState");
        await execute({ path: pathName, locale: locale });
        router.refresh();
      }}
      className={styles.signOutButton}
      aria-label={t("ariaSignOut")}
    >
      <span className={styles.icon}>
        <MdLogout />
      </span>
      {t("signOut")}
    </button>
  );
}
